import RequestsActions from 'client/core/RequestsActions'
import { action } from 'client/core/actions'

export const ReportsRequest = new RequestsActions('REPORTS')
export const ExportReportsRequest = new RequestsActions('EXPORT_REPORTS')

export const REPORTS_FILTERS_CHANGE = 'REPORTS_FILTERS_CHANGE'
export const reportsFiltersChange = (payload) => action(REPORTS_FILTERS_CHANGE, { payload })
export const REPORTS_SEARCH_CHANGE = 'REPORTS_SEARCH_CHANGE'
export const reportsSearchChange = (payload) => action(REPORTS_SEARCH_CHANGE, { payload })

/*Socket connection*/
export const SOCKET_NEW_REPORT = 'SOCKET_NEW_REPORT'
export const socketNewReport = (payload) => action(SOCKET_NEW_REPORT, payload)


// WEBPACK FOOTER //
// ./src/client/features/reports/actions.js